import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import {
  foundSelector,
  notFoundSelector,
  promptSelector,
  setFound,
  setNotFound,
  setPrompt,
  setShowNLPError,
  setShowNoResults,
  showNLPErrorSelector,
} from 'store/reducers/nlp/nlp-reducer';
import { setCurrentTabs } from 'store/reducers/people-steps-reducer/people-steps-reducer';
import {
  emptyAllFilters,
  NLPPeopleGroupsSelector,
  nlpPeopleResultsSelector,
  originalPeopleSelector,
  peopleSelector,
  setCurrentStep,
  setIsPeopleLoading,
  setNLPPeopleResults,
  setPeople,
  setShouldFetch,
  setAdditionalOptionalFilters,
  setShowBackButton,
} from 'store/reducers/people/people-reducer';

export default function usePeopleResetSearch() {
  const dispatch = useDispatch();
  const prompt = useSelector(promptSelector);
  const people = useSelector(peopleSelector);
  const originalPeople = useSelector(originalPeopleSelector);
  const nlpPeopleResults = useSelector(nlpPeopleResultsSelector);
  const showNLPError = useSelector(showNLPErrorSelector);
  const notFound = useSelector(notFoundSelector);
  const nlpGroups = useSelector(NLPPeopleGroupsSelector);
  const nlpFound = useSelector(foundSelector);

  return useCallback(
    ({ step = 1 }: { step?: number } = {}) => {
      if (people.length === 0 || showNLPError) {
        dispatch(setPeople(originalPeople));
      }
      dispatch(setShowBackButton(false));
      dispatch(setShowNLPError(false));
      dispatch(setShowNoResults(false));
      dispatch(setCurrentStep(step));
      dispatch(setPrompt(null));
      dispatch(emptyAllFilters({}));
      dispatch(setAdditionalOptionalFilters({ employees: false, freelancers: false }));
      dispatch(setShouldFetch(true));
      dispatch(setIsPeopleLoading(false));
      dispatch(setCurrentTabs(['most_relevant']));
      dispatch(setNLPPeopleResults([]));
      dispatch(setNotFound(null));
      dispatch(setFound(null));
    },
    [
      dispatch,
      people,
      originalPeople,
      showNLPError,
      prompt,
      nlpPeopleResults,
      notFound,
      nlpGroups,
      nlpFound,
    ]
  );
}
